"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSearchSelect = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _multiSelectModule = _interopRequireDefault(require("./multi-select.module.scss"));
var _common = require("../common");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _excluded = ["value", "onChange", "id", "name", "className", "options", "disabled", "searchable", "clearable", "loading", "placeholder", "small", "menuPlacement", "error", "prefixIcon", "menuPosition", "allowSelectAll"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "value", "data", "isSelected"];
var SELECT_ALL = '<SELECT_ALL>';
var MultiSearchSelect = function MultiSearchSelect(_ref) {
  var _classNames;
  var value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    name = _ref.name,
    className = _ref.className,
    options = _ref.options,
    disabled = _ref.disabled,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? true : _ref$searchable,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? true : _ref$clearable,
    loading = _ref.loading,
    placeholder = _ref.placeholder,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? 'bottom' : _ref$menuPlacement,
    error = _ref.error,
    prefixIcon = _ref.prefixIcon,
    menuPosition = _ref.menuPosition,
    _ref$allowSelectAll = _ref.allowSelectAll,
    allowSelectAll = _ref$allowSelectAll === void 0 ? false : _ref$allowSelectAll,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var getOption = (0, _react.useCallback)(function (value) {
    return options.find(function (o) {
      return o.value === value;
    });
  }, [options]);
  var selectAllOption = {
    value: SELECT_ALL,
    label: t('multiSearchSelect.all')
  };
  var allOptionsSelected = allowSelectAll && value && value.length === options.length;
  var _useState = (0, _react.useState)(allOptionsSelected),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    allSelected = _useState2[0],
    setAllSelected = _useState2[1];
  var _useState3 = (0, _react.useState)(value ? value.map(function (item) {
      return getOption(item);
    }) : null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedOptions = _useState4[0],
    setSelectedOptions = _useState4[1];
  (0, _react.useEffect)(function () {
    if (value === undefined) {
      setSelectedOptions(null);
    } else {
      setSelectedOptions(value.map(function (item) {
        return getOption(item);
      }));
    }
  }, [value, options, getOption]);
  (0, _react.useEffect)(function () {
    setAllSelected(allOptionsSelected);
  }, [allOptionsSelected]);
  var handleToogleAll = (0, _react.useCallback)(function () {
    if (!allSelected) {
      setSelectedOptions(options);
      onChange(options.map(function (option) {
        return option.value;
      }));
    } else {
      setSelectedOptions(null);
      onChange([]);
    }
    setAllSelected(!allSelected);
  }, [allSelected, setSelectedOptions, setAllSelected, onChange, options]);
  var isOptionSelected = function isOptionSelected(option) {
    return selectedOptions !== null && (selectedOptions.some(function (_ref2) {
      var value = _ref2.value;
      return value === option.value;
    }) || allSelected);
  };
  var handleChange = function handleChange(newValue, actionMeta) {
    var action = actionMeta.action,
      option = actionMeta.option;
    var value = newValue.filter(function (item) {
      return item.value !== SELECT_ALL;
    });
    if (action === 'deselect-option' && allSelected) {
      setSelectedOptions(options.filter(function (_ref3) {
        var value = _ref3.value;
        return value !== option.value;
      }).map(function (option) {
        return getOption(option.value);
      }));
      onChange(options.filter(function (_ref4) {
        var value = _ref4.value;
        return value !== option.value;
      }).map(function (option) {
        return option.value;
      }));
    } else {
      setSelectedOptions(value === undefined || value.length === 0 ? null : value.map(function (option) {
        return getOption(option.value);
      }));
      onChange(value.map(function (option) {
        return option.value;
      }));
    }
    if (allowSelectAll && value.length === options.length) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };
  var CustomControl = (0, _react.useCallback)(function (_ref5) {
    var children = _ref5.children,
      rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_common.Control, Object.assign({
      prefixIcon: prefixIcon
    }, rest), children);
  }, [prefixIcon]);
  var CustomOption = (0, _react.useCallback)(function (_ref6) {
    var children = _ref6.children,
      value = _ref6.value,
      data = _ref6.data,
      isSelected = _ref6.isSelected,
      rest = (0, _objectWithoutProperties2.default)(_ref6, _excluded3);
    if (value === SELECT_ALL) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_common.Option, Object.assign({}, rest, {
      isSelected: isSelected
    }), data.dropdownLabel ? data.dropdownLabel : children);
  }, []);
  var Menu = (0, _react.useCallback)(function (props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({
      "data-testid": 'select-menu',
      style: getStyles('menu', props),
      className: cx({
        menu: true
      }, className),
      ref: innerRef
    }, innerProps), children, allowSelectAll && /*#__PURE__*/_react.default.createElement("div", {
      className: _multiSelectModule.default['multi-select__all'],
      onClick: handleToogleAll
    }, allSelected ? t('multiSearchSelect.deselectAll') : t('multiSearchSelect.selectAll')));
  }, [allowSelectAll, allSelected, handleToogleAll, t]);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, Object.assign({
    isOptionSelected: isOptionSelected,
    inputId: id,
    name: name,
    menuPosition: menuPosition,
    menuPortalTarget: menuPosition === 'fixed' ? document.body : undefined,
    className: (0, _classnames.default)(_multiSelectModule.default['select__container'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['select__container--small'], small), (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['select__container--error'], error), (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['select__container--top'], menuPlacement === 'top'), _classNames)),
    styles: {
      menuPortal: function menuPortal(base) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base), {}, {
          zIndex: 250
        });
      }
    },
    components: {
      DropdownIndicator: small ? _common.SmallDropdownIndicator : _reactSelect.components.DropdownIndicator,
      Option: CustomOption,
      Control: CustomControl,
      ClearIndicator: _common.ClearIndicator,
      Menu: Menu
    },
    classNamePrefix: "select",
    placeholder: placeholder,
    value: allSelected ? [selectAllOption] : selectedOptions,
    isDisabled: disabled,
    isSearchable: searchable,
    isClearable: clearable,
    isLoading: loading,
    onChange: handleChange,
    options: allowSelectAll ? [selectAllOption].concat((0, _toConsumableArray2.default)(options)) : options,
    isMulti: true,
    hideSelectedOptions: false,
    closeMenuOnSelect: false,
    noOptionsMessage: function noOptionsMessage() {
      return t('multiSearchSelect.noOptions');
    }
  }, props));
};
exports.MultiSearchSelect = MultiSearchSelect;